import { useContext } from 'react';

import { AppLayoutContext } from '../AppLayoutContextProvider';
import type { AppLayoutContextValue } from '../AppLayoutContextProvider.types';

export const useAppLayoutContext = (): AppLayoutContextValue | undefined => useContext(AppLayoutContext);

export const useRequiredAppLayoutContext = (): AppLayoutContextValue => {
  const context = useAppLayoutContext();

  if (!context) {
    throw new Error('useRequiredAppLayoutContext must be used within an AppLayoutContextProvider');
  }

  return context;
};

type UseAppLayoutWidth = () => number;
export const useAppLayoutWidth: UseAppLayoutWidth = () => useAppLayoutContext()?.width ?? Infinity;

type UseAppLayoutGutterSize = () => number;
export const useAppLayoutGutterSize: UseAppLayoutGutterSize = () => useAppLayoutContext()?.gutterSize ?? 0;
